import * as React from 'react';


import Box from '@mui/material/Box'


import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Button from '@mui/material/Button'
import Card from'@mui/material/Card'
import CardContent from'@mui/material/CardContent'
import CardHeader from'@mui/material/CardHeader'
import { CharismaStudentTrainingApi } from '../api/studentTrainings/CharismaStudentTrainingApi.tsx';
import CharismaLateForm from './lateForm.tsx';
import CharismaFileForm from '../components/fileForm.tsx'
import { CharismaUserContext } from '../context.tsx';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit'
import {formatDate, formatTime} from '../utils.tsx'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';




export default function CharismaLatesList(props){
    
    interface late{
        id: number,
        subject: string,
        fromtDate: string,
        toDate: string,
        attach: string
    }    
   
    const [create, setCreate] = React.useState(false);
    const [latesList, setLatesList] = React.useState([]);
    const [deleteLates, setDeleteLates] = React.useState(false);
    const [selectedLates, setSelectedLates] = React.useState([]);   
    const [currentLate, setCurrentLate] = React.useState(null)
    const [lateId, setLateId] = React.useState(0)
    const [deleteId, setDeleteId] = React.useState(0)
   
    const lCurrentUser = React.useContext(CharismaUserContext);
    const lReadWrite = lCurrentUser !== null && lCurrentUser !== undefined && (lCurrentUser.profile === 0 || lCurrentUser.profile === 3);
    const lStudentTrainingId = props.studentTrainingId;    
    const lStudentId = props.studentId;    

    const lType = props.type

    React.useEffect(()=>{
        const lResponsePeriods = CharismaStudentTrainingApi.ListLates(lStudentTrainingId, lType);
        lResponsePeriods.then((value)=>{
            if(value.error === 0){
                setLatesList(value.lates);
            }
        }).catch((error)=>{
            
        })
    }, [lStudentTrainingId, lType])
    
    
    function handleUpdateLate(pFromDate : string, pToDate : string, pSubject:string, pId: number){
        const lResponse = CharismaStudentTrainingApi.UpdateLate(pSubject, pFromDate, pToDate, pId);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.late !== null){
                    let lLatesList = latesList.slice()
                    for(let index = 0; index < lLatesList.length; index++){
                        let late = lLatesList[index];
                        console.log(late);
                        console.log(value.late);
                        if (late.id === value.late.id){
                            lLatesList[index] = value.late;
                            break;
                        }
                    }
                    setLatesList(lLatesList);
                    setCreate(false);
                    setCurrentLate(null);
                }
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    }
          
    function handleCreateLate(pFromDate : string, pToDate : string, pSubject:string){
        const lResponse = CharismaStudentTrainingApi.CreateLate(pSubject, pFromDate, pToDate, lStudentId, lStudentTrainingId, lType);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.late !== null){
                    let lLates = latesList.concat(value.late);
                    setLatesList(lLates);
                    setCreate(false);
                }
                
            }
            else{
                
            }
        }).catch((error)=>{
                console.log("catch error")
        })
    } 
    
    function handleCancelCreate(){
        setCreate(false);
        setCurrentLate(null)
    }
                    
    function handleDeleteLates(){
        const lResponse = CharismaStudentTrainingApi.DeleteLates(selectedLates, lType);
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.ids !== null){
                    const lIds = value.ids;
                    let lLates = latesList.filter((lLate)=>lIds.indexOf(lLate.id) === -1);
                    setLatesList(lLates);
                    setDeleteLates(false);                  
                }
;            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })           
    }            
    
    function handleSelectedLate(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = selectedLates.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(selectedLates, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(selectedLates.slice(1));
            }
            else if(lIndex === selectedLates.length - 1){
                lNewSelected = lNewSelected.concat(selectedLates.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(selectedLates.slice(0, lIndex), selectedLates.slice(lIndex + 1),);
            }
        }
        setSelectedLates(lNewSelected);
    }
    
    function handleSetJustified(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lJustified = 0;
        if(pEvent.target.checked){
            lJustified = 1;
        }
        const lResponse = CharismaStudentTrainingApi.JustifyLate(lJustified, pId)
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.assessment !== null){
                    const lAssessmentId = value.late.id;
                    let lLates = latesList.slice();
                    for(let lIndex = 0; lIndex < lLates.length; lIndex++){
                        if(lLates[lIndex].id === lAssessmentId){
                            lLates[lIndex].justified = value.late.justified;
                            setLatesList(lLates);
                            break;
                            
                        }
                    }                  
                }
            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })          
    }    
            
    
    function handleCloseEdit(){
        setCurrentLate(null);
    }
    
    function handleEdit(pId : number){
          for(let lIndex = 0; lIndex < latesList.length; lIndex++){
              const lLate = latesList[lIndex];
              if(lLate.id == pId){
                  setCurrentLate(lLate);
                  break;
              }
          } 
    }
    
    function handleCancelDoc(){
        setLateId(0);
    }
    
    function handleDeleteDoc(){
        const lResponse = CharismaStudentTrainingApi.DeleteLateDoc(lStudentId, lStudentTrainingId, deleteId)
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.late !== null){
                    setLateId(0);     
                    let lLates = latesList.slice();
                    for(let index = 0; index < lLates.length; index++){
                        if(lLates[index].id === value.late.id){
                            lLates[index] = value.late;
                            break
                        }
                    }            
                    setLatesList(lLates); 
                    setDeleteId(0);
                }
            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })  
    }
    
    function handleAddDoc(pFile: File){
        const lResponse = CharismaStudentTrainingApi.AddLateDoc(lStudentId, lStudentTrainingId, pFile, lateId)
        lResponse.then((value)=>{
            if(value.error === 0){
                if(value.late !== null){
                    setLateId(0);     
                    let lLates = latesList.slice();
                    for(let index = 0; index < lLates.length; index++){
                        if(lLates[index].id === value.late.id){
                            lLates[index] = value.late;
                            break
                        }
                    }            
                    setLatesList(lLates); 
                }
            }
            else{
            
            }
        }).catch((error)=>{
            console.log("catch error")
        })  
    }    
    
    function createLatesTable(pLates : late[], pSelected : number[]){
        return(
            pLates.map((late)=>(
                <TableRow key={late.id}>
                    {lReadWrite ?
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={pSelected.indexOf(late.id) >= 0}
                                onClick={                                    
                                    (event)=>handleSelectedLate(event, late.id)
                                    }
                            />
                        </TableCell>
                        :
                        null
                    }
                    <TableCell>
                        {late.subject}
                    </TableCell>
                    <TableCell>
                        {formatDate(late.date)}
                    </TableCell>
                    <TableCell>
                        {formatTime(late.hour)}
                    </TableCell>
                    <TableCell>
                        {late.link !== null ?
                            <div>
                                <Link to={late.link} target="_blank" rel="noopener noreferrer" >
                                    <AttachFileIcon/>
                                </Link>
                                <IconButton onClick={()=>setDeleteId(late.id)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </div>
                        :
                            <IconButton onClick={()=>setLateId(late.id)}>
                                <AddIcon/>
                            </IconButton>
                        }
                    </TableCell>
                    <TableCell>
                        <Checkbox
                            checked={late.justified !== undefined ? late.justified : false}
                            disabled={!lReadWrite}
                            onClick={                                    
                                (event)=>handleSetJustified(event, late.id)
                                }
                        />                        
                    </TableCell>
                    {lReadWrite  ?
                        <TableCell padding="checkbox">
                            <IconButton
                                onClick={()=>handleEdit(late.id)}
                            >
                                <EditIcon/>
                            </IconButton>
                        </TableCell>
                        :
                        null
                    }
                </TableRow>
                 
            ))
        )
    }
    
    
    return(
        
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Card>
                        <CardHeader
                            title={props.title}
                            action={
                                <div>
                                {lReadWrite?
                                <div>
                                <IconButton onClick={()=>setCreate(true)}>
                                    <AddIcon/>
                                </IconButton>
                                {selectedLates.length > 0?
                                    <IconButton onClick={()=>setDeleteLates(true)}>
                                        <DeleteIcon/>
                                    </IconButton>  
                                    :
                                    null
                                } 
                                </div>
                                :
                                null
                                }                                
                                </div>
                            }
                        />
                        <CardContent>
                            <Table>                               
                                <TableHead>
                                    <TableRow>
                                        {lReadWrite ?
                                            <TableCell padding="checkbox">
                                                </TableCell>
                                              :
                                              null
                                        }
                                        <TableCell>Motif</TableCell>
                                        <TableCell>Le</TableCell>
                                        <TableCell>{lType === 0 ? "Heure d'arrivée" : "Heure de départ"}</TableCell>
                                        <TableCell>Justificatif</TableCell>
                                        <TableCell>Justifiée</TableCell>
                                        <TableCell padding="checkbox">
                                        </TableCell>                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {
                                    createLatesTable(latesList, selectedLates)
                                }
                                </TableBody>
                            </Table>                            
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            {create ?
                <CharismaLateForm
                    handleSubmit={handleCreateLate}
                    handleCancel={handleCancelCreate}
                    type={lType}
                    title={lType === 0 ? "Nouveau retard" : "Nouveau départ anticipé"}
                />
                :
                null    
            }    
            {currentLate !== null ?
                <CharismaLateForm
                    lateId = {currentLate.id}
                    handleSubmit={handleUpdateLate}
                    handleCancel={handleCancelCreate}
                    subject = {currentLate.subject}
                    lateDate = {currentLate.date}
                    lateHour = {currentLate.hour}
                    type={lType}
                    title={lType === 0 ? "Modification du retard" : "Modification du départ anticipé"}

                />
                :
                null
            }
            
            <Dialog
                open={deleteLates}
            >
                <DialogTitle>Suppression des retard</DialogTitle>
                <DialogContent>
                    <Typography>Etes-vous sûr de vouloir supprimer définitivement les items sélectionnés?</Typography>
                    {
                        false?
                            <Alert severity='info'>Suppression en cours...</Alert>
                        :
                        null
                    }
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteLates(false)}>
                        Annuler
                    </Button>
                    <Button onClick={handleDeleteLates}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={deleteId !== 0}
            >
                <DialogTitle>Suppression du document</DialogTitle>
                <DialogContent>
                    <Typography>Etes-vous sûr de vouloir supprimer définitivement la pièce jointe?</Typography>
                    
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteId(0)}>
                        Annuler
                    </Button>
                    <Button onClick={()=>handleDeleteDoc()}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>            
            {lateId !== 0 ?
                <CharismaFileForm
                    title={'Ajout d\'un document'}
                    handleSubmit={handleAddDoc}
                    handleCancel={handleCancelDoc}
                 />
                 :
                 null
            }                     
        </Box>      
    );
    
    
}